// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"303":"f2ea9fd6","313":"dc39f9bc","592":"08154249"}[chunkId] + ".chunk.js";
};